module.exports = __webpack_public_path__ + "img/back.dad66e99.png";